import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  ...props,
  children: /*#__PURE__*/_jsx("g", {
    fill: "currentColor",
    children: /*#__PURE__*/_jsx("path", {
      d: "M46.7 41.5H1.3c-.7 0-1.3.6-1.3 1.3 0 .6.6 1.2 1.3 1.2h45.5c.7 0 1.3-.6 1.3-1.3-.1-.6-.7-1.2-1.4-1.2zM3.2 19H5v15c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3V19h3.8v18.8H5.1c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3H43c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3h-6.3V19h3.8v15c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3V19h1.8c.7 0 1.3-.3 1.8-.8s.8-1.1.7-1.8c0-1-.6-1.9-1.5-2.3l-20-9.7c-1.2-.6-2.5-.6-3.7 0l-20 9.7c-.6.3-1.1.8-1.3 1.5-.2.6-.2 1.3.1 2 .3.8 1.2 1.4 2.2 1.4zm30.9 18.7H29V26.4c-.2-2.7-2.3-4.8-5.1-4.9-2.8 0-5.1 2.2-5.1 5V34c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3v-7.5c0-1.4 1.1-2.5 2.5-2.5 1.4.1 2.5 1.2 2.6 2.5v11.3H13.9V19h20.2v18.7zm-10.8-31c.2-.1.4-.2.7-.2.2 0 .5.1.7.2l20 9.7v.1H3.2v1.3-1.4l20.1-9.7z"
    })
  })
});